import goldImg from '@/assets/images/img-main-plan-gold@3x.png';
import regularImg from '@/assets/images/img-main-plan-regular@3x.png';
import silverImg from '@/assets/images/img-main-plan-silver@3x.png';
import vipImg from '@/assets/images/img-main-plan-vip@3x.png';

export function provideMemberStyle() {
  const provideMemberIconUrl = (memberType: EnumMemberType): string => {
    switch (memberType) {
      case EnumMemberType.REGULAR:
        return regularImg;
      case EnumMemberType.SILVER:
        return silverImg;
      case EnumMemberType.GOLD:
        return goldImg;
      case EnumMemberType.VIP:
        return vipImg;
      default:
        return '';
    }
  };

  const provideMemberColorTheme = (memberType: EnumMemberType): string => {
    switch (memberType) {
      case EnumMemberType.REGULAR:
        return '#787878';
      case EnumMemberType.SILVER:
        return '#4878D4';
      case EnumMemberType.GOLD:
        return '#D9AA4F';
      case EnumMemberType.VIP:
        return '#B268D1';
      default:
        return '';
    }
  };

  const provideMemberBadgeClass = (memberType: EnumMemberType): string => {
    switch (memberType) {
      case EnumMemberType.SILVER:
        return 'bg-blue-400_a1 text-blue-400';
      case EnumMemberType.VIP:
        return 'bg-purple-400_a1 text-purple-400';
      case EnumMemberType.GOLD:
        return 'bg-brand-400_a1 text-brand-400';
      case EnumMemberType.REGULAR:
      default:
        return 'bg-cyan-400_a1 text-cyan-400';
    }
  };

  return {
    provideMemberIconUrl,
    provideMemberColorTheme,
    provideMemberBadgeClass,
  };
}
